
import React, {Component} from "react";
import * as style from "./style.scss";
import PropTypes from "prop-types";

export default class PageTitle extends Component {


    render() {
        return (
            <div className={style.pageTitle}>
                {this.props.title !== null ? (
                    <h1 className={style.title}>
                        {this.props.title}
                    </h1>
                ) : null}
                {this.props.subTitle !== null ? (
                    <h4 className={style.subTitle}>
                        {this.props.subTitle}
                    </h4>
                ) : null}

            </div>
        )
    }
}

PageTitle.propTypes = {
    title: PropTypes.node,
    subTitle: PropTypes.node
}

PageTitle.defaultProps = {
    title: null,
    subTitle: null
}
